<template>
  <div id="ConfigRecaptcha">
    <b-row>
      <b-col>
        <h2 class="pb-3">ReCaptcha Configuration</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-tabs lazy>
          <b-tab title="Use ReCaptcha" active>
            <ConfigRecaptchaUse />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ConfigRecaptchaUse from '@/views/config/ConfigRecaptchaUse'
export default {
  name: 'ConfigRecaptcha',
  components: {
    ConfigRecaptchaUse
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/config/ConfigRecaptcha.vue